import ReducersFactory from '../../lib/reducers/ReducersFactory';

const questions = new ReducersFactory('questions', [])


export default questions.reducer